import { ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ConveniosHist, ConveniosHistInput, AuxJasper, ParametroJasper } from '../../entidades/entidades';
import { BuscaConveniosService } from '../../servicios/busca-convenios.service';
import { MuestraMensaje } from '../../shared/utilerias/notificaciones/notificaciones.component';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-gestor-convenios',
  templateUrl: './gestor-convenios.component.html',
  styleUrls: ['./gestor-convenios.component.css']
})
export class GestorConveniosComponent implements OnInit {

  gestorconveniosForm: FormGroup;

  auxJasper: AuxJasper;

  public progressBar = false;
  muestraMensaje = new MuestraMensaje();
  _desde: Date;
  _hasta: Date;
  public conveniosHist: ConveniosHist[] = [];


  constructor(private formBuilder: FormBuilder,
              private buscaConveniosService: BuscaConveniosService
  ) { }

  async ngOnInit() {
    this.gestorconveniosForm = this.formBuilder.group({
      idAgua: [null],
      numConvenio: [null, [Validators.pattern(/^[0-9]+$/)]],
      desde: [new Date(), Validators.required],
      hasta: [new Date(), Validators.required]
    });
  }
  async buscarConveniosHist(bci: ConveniosHistInput) {
    try {
        var bci = new ConveniosHistInput(); 
        bci.desde = this._desde;
        bci.hasta = this._hasta;  

        this.progressBar=true;
        const datoretorno = await this.buscaConveniosService
          .getBuscaConvenioHist(bci)
          .toPromise();
          this.conveniosHist = Array.isArray(datoretorno) ? datoretorno : [];
          debugger;

    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      this.progressBar=false;
      console.log("Paso por buscarConveniosHist");
    }
  }
  getColorForPaymentStatusC(convenio: any): string {
      if (convenio.estatus === 'VIGENTE') {
          return '#BEE6A5'; // Verde pastel
      } else if (convenio.estatus === 'TERMINADO') {
          return '#D3D3D3'; // Gris pastel
      } else if (convenio.estatus === 'CANCELADO') {
          return '#F5A3A3'; // Rojo pastel
      } else {
          return 'transparent'; // Sin color
      }
  }
  async conveniosHistExcel() {
    try {
      this.progressBar = true; 
      if (!this._desde || !this._hasta) {
        this.muestraMensaje.error('Ingrese un rango de fechas.', "top", "center");
      }
      else {
      this.auxJasper = new AuxJasper();
      this.auxJasper.JasperReport.nombreReporte = "040_Convenios_Hist";
      this.auxJasper.JasperReport.tipo = "xlsx"; 

      
      const parametroJasper = new ParametroJasper();
        parametroJasper.nombre = "_desde";
        parametroJasper.valor = this._desde + '';

        const parametroJasper2 = new ParametroJasper();
        parametroJasper2.nombre = "_hasta";
        parametroJasper2.valor = this._hasta + '';
      //this.showDialog();

    
      await this.auxJasper.ParametroJasper.push(parametroJasper);
      await this.auxJasper.ParametroJasper.push(parametroJasper2);

      console.log("040_Convenios_Hist exportado a Excel");
      }
    } catch (error) {
      if (error.response) throw { message: error.response.data };
      else throw error;
    }finally{
      setTimeout(() =>{
        this.progressBar = false;
      }, 5000);
    }
  }

}
